<template>
	<div class="status-indicator" :class="flowStatusClass">
		{{ statusText }}
	</div>
</template>

<script>
import { getStatusText, getFlowStatusClass } from '../TaskLogService';

export default {
	name: 'StatusIndicator',
	props: {
		status: String,
	},
	computed: {
		statusText() {
			return getStatusText(this.status);
		},

		flowStatusClass() {
			return getFlowStatusClass(this.statusText);
		},
	},
};
</script>

<style scoped lang="scss">
.status-indicator {
	width: 80px;
	height: 22px;
	border-radius: 4px;
	border: 1px solid transparent;
	box-sizing: border-box;
	background: transparent;
	transition: all 0.2s 2s;
	line-height: 19px;
	text-align: center;
	font-size: 11px;
	text-transform: capitalize;
	animation: 1.5s ease-out 0s 1 fainInAnimation;

	&.green_status {
		background: #d5f3ed;
	}
	&.green_status {
		color: #1bbc9c;
	}

	&.orange_status {
		background: #fff3e8;
	}
	&.orange_status {
		color: #faaa5a;
	}

	&.red_status {
		background: #ffe3ed;
	}
	&.red_status {
		color: #e95454;
	}

	&.grey_status {
		background: #e8eaed;
	}
	&.grey_status {
		color: #5a677d;
	}

	&.blue_status {
		background: #e8effe;
	}
	&.blue_status {
		color: #5b8af7;
	}

	@keyframes fainInAnimation {
		from {
			opacity: 0;
		}
		to {
			opacity: 1;
		}
	}
}
</style>
